import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import { NoteCaptureCard } from './shared.style';

export const Card = styled(NoteCaptureCard)`
  align-items: flex-start;
  padding: 10px;
  gap: 10px;
  border-radius: 35px;
  box-sizing: border-box;
  min-height: 360px;

  @media (min-width: ${breakpoints.tabletMin}) {
    max-width: 600px;
  }
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 5px 5px 0;
  box-sizing: border-box;
`;

export const TextInputSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  padding: 5px;
  width: 100%;
  box-sizing: border-box;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 60px;
  max-height: 200px;
  padding: 0;
  border: none;
  outline: none;
  resize: none;
  background: transparent;
  box-sizing: border-box;
  font-family: 'Inter Variable', 'Inter', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colours.neutral[900]};

  &::placeholder {
    color: ${colours.neutral[400]};
  }
`;

export const ControlsSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  width: 100%;
  box-sizing: border-box;
`;

export const ControlsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AttachmentError = styled.div`
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  font-family: 'Inter Variable', 'Inter', sans-serif;
  font-size: 13px;
  line-height: 18px;
  color: ${colours.primary[500]};
`;
